import { PROGRAM_PLAN_CONTENT_TYPE } from "../constants";

export const INSTANCE_API_FIELD = {
  [PROGRAM_PLAN_CONTENT_TYPE.WORKOUT]: 'workout',
  [PROGRAM_PLAN_CONTENT_TYPE.ARTICLE]: 'content',
  [PROGRAM_PLAN_CONTENT_TYPE.AUDIO]: 'content',
  [PROGRAM_PLAN_CONTENT_TYPE.VIDEO]: 'content',
  [PROGRAM_PLAN_CONTENT_TYPE.RECIPE]: 'recipe',
}
